import { secondsToTimecodeFrame } from 'weave-timeline';

export function formatFrames(currentTime: number, fps: number): string {
  return String(secondsToTimecodeFrame(currentTime, fps));
}

export function parseFrames(input: string): number | null {
  const trimmed = input.trim();
  if (!/^\d+$/.test(trimmed)) return null;
  return Number(trimmed);
}
